import { OnboardingBackgroundShader } from "./OnboardingBackgroundShader";

/** Full-screen hold state while onboarding illustrations decode — matches shell background, no placeholder box. */
export function OnboardingBootHold() {
  return (
    <div
      className="fixed inset-0 z-50 flex min-h-[100svh] flex-col text-[oklch(90%_0.02_150)]"
      aria-busy="true"
      aria-label="Loading"
    >
      <OnboardingBackgroundShader />
    </div>
  );
}
